export default {
  loading: "Cargando...",
  loadingLogoAlt: "Cargando",
  signingIn: "Iniciando sesión...",
  signIn: "Sign in",
  signInTitle: "Iniciar sesión",
  email: "Email",
  password: "Password",
  forgotPassword: "Olvidaste tu contraseña?",
  recoverPassword: "Recuperar contraseña",
  recoverPasswordTitle: "Recuperar contraseña",
  recoverPasswordHint:
    "Ingresá tu email y te enviaremos instrucciones para restablecer tu contraseña.",
  recoverPasswordSuccess:
    "Te enviamos un enlace para restablecer tu contraseña.",
  recoverPasswordError: "Ocurrió un error al enviar el email.",
  networkError: "Ocurrió un error de red.",
  invalidCredentials:
    "Credenciales inválidas. Por favor, verifica tu email y contraseña.",
  loginError: "Error al iniciar sesión. Intenta nuevamente.",
  demoTitle: "Demo - Acceso Rápido",
  createAccount: "Crear Cuenta",
  register: "Registro",
  access: "Acceso",
  noAccount: "¿No tenés cuenta?",
  hasAccount: "¿Ya tenés cuenta?",
  registerHere: "Registrate acá",
  loginHere: "Iniciá sesión",
  confirmEmailTitle: "Confirma tu email",
  confirmEmailSent: "Te hemos enviado un email de confirmación a:",
  confirmEmailHint:
    "Haz clic en el enlace del email para activar tu cuenta y poder iniciar sesión.",
  confirmEmailNoLongerRequired:
    "La confirmación por email ya no es necesaria. Puedes iniciar sesión con tus credenciales.",
  confirmEmailNoReceived: "¿No recibiste el email?",
  confirmEmailCheckSpam: "Revisa tu carpeta de spam o correo no deseado.",
  confirmEmailContactSupport: "Si sigues teniendo problemas, contacta con soporte.",
};
